import { render, staticRenderFns } from "./DeviceListWithNewProduct.vue?vue&type=template&id=5b7e8311&scoped=true"
import script from "./DeviceListWithNewProduct.vue?vue&type=script&lang=js"
export * from "./DeviceListWithNewProduct.vue?vue&type=script&lang=js"
import style0 from "./DeviceListWithNewProduct.vue?vue&type=style&index=0&id=5b7e8311&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e8311",
  null
  
)

export default component.exports